/* eslint-disable */
import { createSelector } from 'reselect';
import { store as authStore } from '@febos-io/auth';
import { DateTime } from 'luxon';
import { initialState } from './reducer';

export const getState = (state) => {
  return {
    ...initialState,
    ...state.healthCommon
  };
};
export const selectSelectedPatient = createSelector(getState, (state) => state.selectedPatient);
export const getLists = createSelector(getState, (state) => state.lists || {});
export const getLastSelected = createSelector(getState, (state) => state.lastSelected || {});

export const getLoading = createSelector(getState, (state) => state.loading || {});

export const getPatientList = createSelector(getLists, authStore.getCompanyId, (lists, companyId) =>
  Object.values(lists[companyId]?.patients || {}).sort((a, b) => a.name.localeCompare(b.name))
);

export const getSettings = createSelector(getLists, authStore.getCompanyId, (lists, companyId) => {
  return lists[companyId]?.configurations || {};
});

export const getExams = createSelector(getLists, authStore.getCompanyId, (lists, companyId) =>
  Object.values(lists[companyId]?.exams || {}).sort((a, b) => a.name.localeCompare(b.name))
);

export const getLastSelectedClinic = createSelector(
  getLastSelected,
  authStore.getCompanyId,
  (selected, companyId) => selected[companyId]?.clinic || undefined
);

export const getClinics = createSelector(getLists, authStore.getCompanyId, (lists, companyId) =>
  Object.values(lists[companyId]?.clinics || {}).sort((a, b) => a.name.localeCompare(b.name))
);
export const getLoadingClinics = createSelector(getLoading, (loading) => loading.clinics || false);

export const getLoadingUsers = createSelector(getLoading, (loading) => loading.users || false);

export const getUsers = createSelector(
  [getState, authStore.getCompanyId, (state, filter) => filter],
  (state, companiId, filter) => {
    return state.users[companiId]?.[filter]?.users || {};
  }
);

export const getLoadingExams = createSelector(
  getLoading,
  (loading) => loading.exams?.loading || false
);
export const getLoadingPatients = createSelector(
  getLoading,
  (loading) => loading.patients || false
);

export const getSchedulersLoading = createSelector(
  getLoading,
  (loading) => loading.schedulers || false
);
export const getAppointmentsLoading = createSelector(
  getLoading,
  (loading) => loading.appointments || false
);

export const getReserveAppointmentsLoading = createSelector(
  getLoading,
  (loading) => loading.reservingAppointments || false
);

// Selector tipado para obtener scheduler de usuario
export const getSchedulerUser = createSelector(
  [getLists, authStore.getCompanyId, (state, params) => params],
  (lists, companyId, { locationId, resourceId }) => {
    // Validar que tenemos los parámetros necesarios
    if (!locationId || !resourceId) {
      return undefined;
    }

    // Navegar por la estructura del estado
    const companyData = lists[companyId];
    if (!companyData) {
      return undefined;
    }
    const schedulers = companyData.schedulers;
    if (!schedulers) {
      return undefined;
    }
    const locationData = schedulers[locationId];
    if (!locationData) {
      return undefined;
    }
    if (!resourceId || resourceId === '*') {
      const allConfig = Object.values(locationData);
      return allConfig.reduce((acc, item) => ({ ...acc, ...item }), {});
    }
    return locationData[resourceId];
  }
);
export const getAppointmentsUser = createSelector(
  [getLists, authStore.getCompanyId, (state, params) => params],
  (lists, companyId, { locationId, resourceId, startDate, endDate }) => {
    // Validar que tenemos los parámetros necesarios
    if (!locationId || !resourceId || !startDate || !endDate) {
      return [];
    }
    // Navegar por la estructura del estado
    const companyData = lists[companyId];
    if (!companyData) {
      return [];
    }
    const appointments = companyData.appointments;
    if (!appointments) {
      return [];
    }
    const locationData = appointments[locationId];
    if (!locationData) {
      return [];
    }
    let appointmentInDates = [];
    const start = new Date(startDate);
    const end = new Date(endDate);
    for (let date = start; date <= end; date.setDate(date.getDate() + 1)) {
      const luxonDate = DateTime.fromJSDate(date);
      const fecha = luxonDate.toISODate();
      const appointmentsForDate = locationData[fecha] || [];
      if (!resourceId || resourceId === '*') {
        appointmentInDates = appointmentInDates.concat(appointmentsForDate);
      } else {
        appointmentInDates = appointmentInDates.concat(
          appointmentsForDate.filter((appointment) => appointment.resourceId === resourceId)
        );
      }
    }
    return appointmentInDates;
  }
);


export const getMyAppointmentsUser = createSelector(
  [getLists, (state, params) => params],
  (lists, {  }) => {
    // Validar que tenemos los parámetros necesarios
    const companyId = '0'
    const locationId = '0'
    // Navegar por la estructura del estado
    const companyData = lists[companyId];
    if (!companyData) {
      return [];
    }
    const appointments = companyData.appointments;
    if (!appointments) {
      return [];
    }
    const locationData = appointments[locationId];
    if (!locationData) {
      return [];
    }
    let appointmentInDates = [];
    for (const key in locationData) {
      const appointmentsForDate = locationData[key] || [];
      appointmentInDates = appointmentInDates.concat(appointmentsForDate);
    }
    // sort appointmentInDates by fecha and horaFin
    appointmentInDates.sort((a, b) => {
      const aDate = new Date(a.fecha + ' ' + a.horaFin);
      const bDate = new Date(b.fecha + ' ' + b.horaFin);
      return aDate - bDate;
    });
    return appointmentInDates;
  }
);

export const getSchedulerStatesLoading = createSelector(
  getLoading,
  (loading) => loading.schedulerStates || false
);

export const getSchedulerStates = createSelector(
  [getLists, authStore.getCompanyId],
  (lists, companyId) => {
    const companyData = lists[companyId];
    if (!companyData || !companyData.schedulerStates) {
      return {};
    }
    return companyData.schedulerStates;
  }
);

export const getSchedulerStatesList = createSelector(getSchedulerStates, (schedulerStates) =>
  Object.values(schedulerStates).sort((a, b) => a.position - b.position)
);

export const getPendingFiles = createSelector(getState, (state) => state.pendingFiles || {});

export const getPendingFilesForClinic = createSelector(
  [getPendingFiles, (state, clinicId) => clinicId],
  (pendingFiles, clinicId) => pendingFiles[clinicId] || {}
);

const isAvalaibleForPatient = (file, patient) => {
  if (Boolean(file?.examCode)) {
    return false;
  }
  if (!patient) {
    return true;
  }
  if (!file.patientId || file.patientId == '0') {
    return true;
  }
  if (
    file.patientId.toLowerCase().replace('.', '').replace('-', '').trim() ===
    patient.identificationNumber.toLowerCase().replace('.', '').replace('-', '').trim()
  ) {
    return true;
  }
  return false;
};
export const getPendingFilesForCurrentClinicPatient = createSelector(
  getPendingFiles,
  authStore.getClinicId,
  selectSelectedPatient,
  (pendingFiles, clinicId, paciente) => {
    const pendientes = pendingFiles[clinicId] || {};
    // filtrar solo objetos que no tengan examCode
    const filtered = Object.values(pendientes).filter(
      (file) =>
        !Boolean(file?.examCode) &&
        (!file.patientId ||
          !paciente ||
          file.patientId == '0' ||
          file.patientId == paciente.identificationNumber ||
          file.patientId == paciente.id)
    );
    return filtered.reduce((acc, file) => {
      if (!file) {
        return acc;
      }
      acc[file.id] = file;
      return acc;
    }, {});
  }
);

export const getCountPendingFilesForCurrentClinicPatient = createSelector(
  getPendingFilesForCurrentClinicPatient,
  (pendingFiles) => Object.values(pendingFiles || {}).length
);

export const getPendingFilesForCurrentClinic = createSelector(
  getPendingFiles,
  authStore.getClinicId,
  selectSelectedPatient,
  (pendingFiles, clinicId, paciente) => {
    const pendientes = pendingFiles[clinicId] || {};
    // filtrar solo objetos que no tengan examCode
    const filtered = Object.values(pendientes).filter((file) => !Boolean(file?.examCode));
    return filtered.reduce((acc, file) => {
      if (!file) {
        return acc;
      }
      acc[file.id] = file;
      return acc;
    }, {});
  }
);

export const getPendingFileById = createSelector(
  [getPendingFiles, (state, clinicId) => clinicId, (state, clinicId, fileId) => fileId],
  (pendingFiles, clinicId, fileId) => pendingFiles[clinicId]?.[fileId] || null
);

export * from './selectors_ts';
